<ion-img [src]="proxiedSrc" [alt]="alt"></ion-img>
